export default props => ({
    actionFont: `400 ${props.theme.type.type_1} ${props.theme.font.default}`,
    actionMargin: `${props.theme.spacingXl} 0 0`,
    actionsMargin: '0 0 0 4.5rem',
    actionsMarginMobile: `${props.theme.spacingXl} 0 0`,
    buttonMaxWidth: props.theme.horizontalLayout2xl,
    cookiePadding: `${props.theme.spacing2xl} 3.125rem`,
    cookiePaddingMobile: `${props.theme.spacingLg} ${props.theme.horizontalSpacing2xl}`,
    linkColor: props.theme.brand01,
    linkMarginMobile: `${props.theme.spacingXl} 0 0`,
    textColor: props.theme.text06,
    textFont: `300 ${props.theme.type.type0} ${props.theme.font.default}`,
    textFontMobile: `300 ${props.theme.type.type_1} ${props.theme.font.default}`,
    textMargin: `${props.theme.spacingMd} 0 0`,
    titleColor: props.theme.black,
    titleFont: `300 ${props.theme.type.type5} ${props.theme.font.default}`,
    titleFontMobile: `300 ${props.theme.type.type1} ${props.theme.font.default}`,

    ...props.theme?.templates?.cookieBanner
  });
